/**
 * @Desc
 * @Author mileS
 * @Date 2020-06-09 10:28
 * */

// 家长端
const parent = {
  id: '1',
  list: [
    {
      title: '未来魔法校·家长APP',
      des: '手机扫描二维码，下载安装',
      pic: require('../../../assets/images/logo/app-parent.png'),
      type: 1,
      code: [
        {
          url: require('../../../assets/images/logo/parent-iphone.png'),
          platform: 'iPhone 下载',
          platformId: 2
        },
        {
          url: require('../../../assets/images/logo/parent-android.png'),
          platform: 'android 下载',
          platformId: 1
        }
      ]
    },
    {
      title: '直播云·学生APP',
      des: '手机扫描二维码，下载安装',
      pic: require('../../../assets/images/logo/live-logo.png'),
      type: 1,
      code: [
        {
          url: require('../../../assets/images/logo/live-iphone.png'),
          platform: 'iPhone 下载',
          platformId: 2
        },
        {
          url: require('../../../assets/images/logo/live-android.png'),
          platform: 'android 下载',
          platformId: 1
        }
      ]
    },
    {
      title: '直播云·学生IPad',
      des: 'IPad扫码二维码，下载安装',
      pic: require('../../../assets/images/logo/live-logo-ipad.png'),
      type: 1,
      code: [
        {
          url: require('../../../assets/images/logo/live-ipad.png'),
          platform: 'IPad 下载',
          platformId: 5
        }
      ]
    },
    {
      title: '直播云·学生PC端',
      des: '点击按钮，下载安装',
      pic: require('../../../assets/images/logo/live-logo.png'),
      type: 2,
      code: [
        {
          needLoad: 'liveCloudStudentPath',
          platform: 'PC客户端下载',
          platformId: 3
        }
      ]
    }
  ]
}

// 老师端
const teacher = {
  id: '1',
  list: [
    {
      title: '未来魔法校·老师APP',
      des: '手机扫描二维码，下载安装',
      pic: require('../../../assets/images/logo/app-teacher.png'),
      type: 1,
      code: [
        {
          url: require('../../../assets/images/logo/teacher-iphone.png'),
          platform: 'iPhone 下载'
        },
        {
          url: require('../../../assets/images/logo/teacher-android.png'),
          platform: 'android 下载'
        }
      ]
    },
    {
      title: '魔法黑板',
      des: '点击按钮，下载安装',
      pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/app9.png',
      type: 2,
      code: [
        {
          needLoad: 'aiBoardLink',
          platform: 'PC客户端下载',
          platformId: 3
        },
        {
          needLoad: 'macBoardLink',
          platform: 'Mac客户端下载',
          platformId: 4
        }
      ]
    },
    {
      title: 'Phoenix·辅导端Pad',
      des: 'iPad扫描二维码，下载安装',
      pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/app10.png',
      type: 1,
      code: [
        {
          url: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/phoenix-pad-ios.png',
          platform: 'IPad 下载',
          platformId: 5
        }
      ]
    },
    {
      title: '直播云·老师PC端',
      des: '点击按钮，下载安装',
      pic: require('../../../assets/images/logo/live-logo-teacher.png'),
      type: 2,
      code: [
        {
          needLoad: 'liveCloudTeacherPath',
          platform: 'PC客户端下载',
          platformId: 3
        }
      ]
    }
  ]
}

// 教室端
const room = {
  list: [
    {
      title: '课中互动系统·PC端',
      des: '点击按钮，下载安装',
      pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/app5.png',
      type: 2,
      code: [
        {
          needLoad: 'classSystemLink',
          platform: 'PC客户端下载',
          platformId: 3
        }
      ]
    },
    {
      title: '音视频系统',
      des: '点击按钮，下载安装',
      pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/app6.png',
      type: 2,
      code: [
        {
          needLoad: 'videoLink',
          platform: 'PC客户端下载',
          platformId: 3
        }
      ]
    },
    {
      title: '谷歌浏览器',
      des: '点击按钮，下载安装',
      pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/app7.png',
      type: 2,
      code: [
        {
          needLoad: 'chromeLink',
          platform: 'PC客户端下载',
          platformId: 3
        }
      ]
    },
    {
      title: 'Phoenix·PC端',
      des: '点击按钮，下载安装',
      pic: 'https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/app10.png',
      type: 2,
      code: [
        {
          needLoad: 'AILink',
          platform: 'PC客户端下载',
          platformId: 3
        }
      ]
    }
  ]
}

const list = [ parent, teacher, room ]

const platformMapper = [
  {
    id: 1,
    name: 'android 下载'
  },
  {
    id: 2,
    name: 'iPhone 下载'
  },
  {
    id: 3,
    name: 'PC客户端下载'
  },
  {
    id: 4,
    name: 'Mac客户端下载'
  },
  {
    id: 5,
    name: 'IPad 下载'
  }
]

export { list, platformMapper }
